import RoomIcon from '@material-ui/icons/Room';
import { QuotedMessage } from '@src/types';
import { useIntl } from 'react-intl';

type ChatMessageLocationQuotedProps = {
  title: React.ReactNode;
  message: QuotedMessage;
};

const ChatMessageLocationQuoted: React.FC<ChatMessageLocationQuotedProps> = ({
  title,
  message,
}) => {
  const intl = useIntl();
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {title}
      <div className="ChatMessageContentQuoted">
        <RoomIcon style={{ marginLeft: -4 }} />
        {message?.text?.length
          ? message.text
          : intl.formatMessage({ id: 'AgentChatTimeline.location.text' })}
      </div>
    </div>
  );
};

export default ChatMessageLocationQuoted;
